import Api from "../Api/Api";

export const getEvents = (search, page, page_size, sort_by, event_status, app_type, prepaid_filter) => {
  const fiveOnOnly = app_type === "3plus" ? "&app_type_gte=3" : "";
  const encodedSearch = search != null ? encodeURIComponent(search) : "";
  return Api.get(
    `event/getEvents?search=${encodedSearch}&page_no=${page}&page_size=${page_size}&sort_by=${sort_by}&event_status=${event_status}&app_type=${app_type}&prepaid_filter=${prepaid_filter}${fiveOnOnly}`
  );
};

export const getEventDetails = (data) => {
  return Api.get(`event/getEvents?event_id=${data}`);
};

export const getEventParticipants = (eventId) => {
  return Api.get(`admin/getEventParticipants?event_id=${eventId}`);
};

export const removeParticipantFromEvent = (data) => {
  return Api.post("admin/removeParticipantFromEvent", data);
};

export const getEventQuestions = (data) => {
  return Api.get(`event/getQuestions?event_id=${data}`);
};

export const getEventPayout = (data) => {
  return Api.get(`admin/getEventPayout?event_id=${data}`);
};

export const getEventSettleups = (eventId) => {
  return Api.get(`admin/getSettleups?event_id=${eventId}`);
};

export const openAllBets = (data) => {
  return Api.post(`admin/openAllBets?event_id=${data}`);
}

export const uncallAllBetsAndOpenEvent = (data) => {
  return Api.post(`admin/uncallAllBetsAndOpenEvent?event_id=${data}`);
}

export const prepayEvent = (eventId) => {
  return Api.post(`event/prepayEvent`, { event_id: eventId });
};

// New bet-related functions
export const getAllBets = (eventId) => {
  return Api.get(`/admin/getAllBets?event_id=${eventId}`);
};

export const deleteBet = (betId) => {
  return Api.delete(`/admin/deleteBet?bet_id=${betId}`);
};

export const deleteAllBets = (eventId) => {
  return Api.delete(`/admin/deleteAllBets?event_id=${eventId}`);
};

export const getEventSummaryData = (eventId) => {
  return Api.get(`/admin/getEventSummaryData?event_id=${eventId}`);
};

export const deleteEvent = (eventId) => {
  return Api.delete(`/admin/deleteEvent?event_id=${eventId}`);
};

export const toggleSocialIncentive = (eventId) => {
  return Api.post(`/admin/toggleSocialIncentive`, { event_id: eventId });
};